export const GET_STRUCTURER_REQUEST = 'GET_STRUCTURER_REQUEST';
export const GET_STRUCTURER_SUCCESS = 'GET_STRUCTURER_SUCCESS';
export const GET_STRUCTURER_ERROR = 'GET_STRUCTURER_ERROR';
